module.exports = __webpack_public_path__ + "static/media/gameOver_modal.6122801e.svg";